// React Imports
import * as React from "react";
import {useState, useEffect, createContext} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
// import {GridToolbarContainer, GridToolbarExport} from '@mui/x-data-grid';
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid-pro";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import {InputLabel, Select, Stack, Tooltip} from "@mui/material";
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import {DataGridPro} from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";
import RefreshIcon from '@mui/icons-material/Refresh';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Typography from "@mui/material/Typography";
import ExpandIcon from '@mui/icons-material/Expand';
// App Imports
import {
    executeExpression
} from "../../ContractDataPoint/ContractDataPointClient";
import Button from "@mui/material/Button";
import {
    advanceApprovedByGuild,
    advanceContract,
    getMissingInput
} from "../../Contract/ContractClient";
import {changeWorkQueue} from "../workQueueSlice";
import WorkQueueDrawer from "../ContractDataPoints/WorkQueueDrawer";

import {
    applyDefault, getBulkEditListV2, getCdpvPivot,
    updateRelatedExpressions
} from "../../ContractDataPointValue/ContractDataPointValueClient";
import {changeContractDataPoint} from "../../ContractDataPoint/contractDataPointSlice";
import {getAllDataPointAttributes, getPivotAttributes} from "../../DataPointAttribute/DataPointAttributeClient";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Drawer from "@mui/material/Drawer";


// main function
export default function CdpvPivot(props) {


    const [attributes, setAttributes] = useState([]);

    // const selectorAttributeId = 263;
    const selectorAttributeDataPointId = useSelector((state) => state.workQueueSlc.value.selectedAttributeDataPointId);
    const selectorAttributeDataPointName = useSelector((state) => state.workQueueSlc.value.selectedAttributeDataPointName);
    const selectorAttributeId = useSelector((state) => state.workQueueSlc.value.selectedAttributeId);
    const selectorContractId = useSelector((state) => state.workQueueSlc.value.selectedContractId);
    const selectorVersionNumber = useSelector((state) => state.workQueueSlc.value.selectedVersionNumber);
    const [rowsIn, setRowsIn] = useState([]);
    const [pivotedRows, setPivotedRows] = useState([]);
    const [columns, setColumns] = useState([]);

    const [attributeId, setAttributeId] = useState( null);

    const hideActions = localStorage.getItem('hideActions') === "true";

    const dispatchData = useDispatch();


    const cdpvPivotRefresh = useSelector((state) => state.workQueueSlc.value.cdpvPivotRefresh);


    const fetchAttributesForDropdowns = () =>
        // getAllDataPointAttributes()
            getPivotAttributes(selectorAttributeDataPointId)

            .then(data => {
                console.log("selectorAttributeDataPointId ", selectorAttributeDataPointId);
                console.log("Attributes List");
                console.log(data);
                // dispatchData(changeWorkQueue({selectedAttributeId: selectedValue}));
                setAttributes(data);

            })
    useEffect(() => {
        console.log("This is for the attributes dropdown...");
        console.log("selectorAttributeDataPointId ", selectorAttributeDataPointId);
        fetchAttributesForDropdowns();
    }, []);



    useEffect(() => {
        // if (!cdpvPivotRefresh) return;
        fetchCdpvPivot();
        dispatchData(changeWorkQueue({ cdpvPivotState: true, cdpvPivotRefresh: false }));
    }, [cdpvPivotRefresh,selectorAttributeId, selectorContractId, selectorVersionNumber]);

    const handleRefreshGrid = () => {
        dispatchData(changeWorkQueue({cdpvPivotRefresh: true}));
    };


    const handleBackButton = () => {
        dispatchData(changeWorkQueue({cdpvPivotState: false}));
    };


    const handleAttributeChange = (selectedValue) => {
        dispatchData(changeWorkQueue({selectedAttributeId: selectedValue, cdpvPivotRefresh: true}));
    };


    const handleAttributeClear = () => {
        setAttributeId(null);
        dispatchData(changeWorkQueue({cdpvPivotRefresh: true}));
    };


    const handleClose = () => {
        setAttributeId(null);
        dispatchData(changeWorkQueue({selectedAttributeId: null, cdpvPivotState: false}));
    };


    const fetchCdpvPivot = () => {
        if (selectorAttributeId != null && selectorContractId != null) {
            console.log("fetching cdpv pivot data.");
            console.log("attributeId = ", selectorAttributeId);
            console.log("contractId = ", selectorContractId);
            console.log("versionNumber = ", selectorVersionNumber);
            getCdpvPivot(selectorAttributeId, selectorContractId, selectorVersionNumber)

                .then(data=>setRowsIn(data)
                 )
                .catch(err => console.error("getCdpvPivot failed", err))
        .finally(() => {console.log("getCdpvPivot completed");
            console.log("pivot data");
        console.log(rowsIn)});
        }
    };


    const handleMegaPivot = () => {
        console.log("Show Mega Pivot");
        dispatchData(changeWorkQueue({cdpvMegaPivotState: true}));
    };

    function buildColumns(pivotedRows) {
        const colNames = new Set();
        for (const row of pivotedRows) {
            Object.keys(row).forEach((k) => {
                // if (k !== "id" && k !== "iterationNumber") colNames.add(k);
                if (k !== "id" && k !== "rowNum") colNames.add(k);
            });
        }

        return [
            { field: "rowNum", headerName: "#", width: 20
                // , hide: true
            },
            // ...Array.from(colNames).sort().map((name) => ({
            ...Array.from(colNames).map((name) => ({
                field: name,
                headerName: name,
                flex: 1,
                align: 'right',
                headerAlign: 'right',
                minWidth: 240,
                headerClassName: "wrap-header",
            })),
        ];
    }

    function pivotForDisplay(rowsIn) {
        const byIter = new Map();

        for (const r of rowsIn) {
            if (!byIter.has(r.rowNum)) {
                byIter.set(r.rowNum, {
                    id: r.rowNum,               // REQUIRED
                    rowNum: r.rowNum,
                });
            }
            byIter.get(r.rowNum)[r.dataPointName] = r.displayValue;
        }

        return Array.from(byIter.values()).sort(
            (a, b) => a.rowNum - b.rowNum
        );
    }

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarExport excelOptions={{ fileName: "cdpv-pivot" }} />
            </GridToolbarContainer>
        );
    }

    useEffect(() => {
        const pivoted = pivotForDisplay(rowsIn);
        setPivotedRows(pivoted);
        setColumns(buildColumns(pivoted));
    }, [rowsIn]);

    return (
        <div style={{ height: '100%' , width: '100%' }}>
            {/*<Box style={{ height: 40}}/>*/}
            <Box style={{ height: 20}}/>
            <Stack direction="row" spacing={2} alignItems="center">
            <Typography
                onClick={() => handleClose()}
                style={{cursor: 'pointer'}}
                sx={{pl:2, fontSize: 24, fontWeight: 'Bold' }}
            >Pivot</Typography>
                <Tooltip enterDelay={1000} title={"Include Peers"}>
                <IconButton onClick={() => handleMegaPivot()}
                            // sx={{pt: 0}}
                            sx={{
                                p: 0,                 // remove default padding
                                display: 'flex',
                                alignItems: 'center', // vertical center
                                justifyContent: 'center',
                                height: '100%',       // important if parent has height
                            }}
                >
                    <ExpandIcon color="primary"  variant="standard"  />
                </IconButton>
                </Tooltip>
            </Stack>
            <br/>

            <Stack direction="row" spacing={2} alignItems="center">
                <Box>
                    <Tooltip title={"contract id: " + selectorContractId}>
                        <Typography sx={{pl: 2, pr: 3, pt: 2, fontWeight: 'bold' }}
                                    style={{cursor: 'pointer'}}
                                    onClick={() => handleClose()}
                        >View By Attribute</Typography>
                    </Tooltip>
                </Box>


            <FormControl variant="standard" sx={{  minWidth: 600 }}>
                <InputLabel htmlFor="xyz"  onClick={handleAttributeClear}>Attributes for {selectorAttributeDataPointName}</InputLabel>
                <Select
                    isClearable={true}
                    id="my_attribute_id"

                    onChange={(event) => {
                        const selectedValue = event.target.value;
                        setAttributeId(selectedValue);
                        handleAttributeChange(selectedValue);
                        // selectedAttributeId(selectedValue)
                    }}
                    // type= "submit"
                    defaultValue=  {attributeId}
                    value = {attributeId}
                >
                        {attributes.map((AttributeItem) =>
                            <MenuItem value={AttributeItem.id}>{AttributeItem.name}</MenuItem>
                        )}
                </Select>
            </FormControl>

            </Stack>
            <br/>

            <br/>
            <DataGridPro
                showToolbar
                columnHeaderHeight={80}
                sx={{
                    "& .wrap-header .MuiDataGrid-columnHeaderTitle": {
                        whiteSpace: "normal",
                        lineHeight: 1.2,
                        overflow: "visible",
                        textOverflow: "clip",
                    },
                }}
                style={{ height: '800px' , width: '1700px' }}
                aria-label={"CdpvPivot"}
                rows={pivotedRows}
                rowThreshold={0}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={columns}
                density={"compact"}
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'iterationNumber', sort: 'asc' }],
                    },
                }}
                components={{
                    Toolbar: CustomToolbar,
                }}
                // slots={{ toolbar: CustomToolbar }}
            />

        </div>
    );



}




